import ManageVideoUpload from './ManageVideoUpload';

export default ManageVideoUpload;
